<template>
  <div>
    <vx-card>
      <div>
        <b-row align-h="end">
          <b-col lg="3" sm="6">
            <v-select
              v-model="secilenDurum"
              :options="durumList"
              label="name"
              placeholder="2014"
              style=""
              @input="yilDeger()"
            >
            </v-select>
          </b-col>
        </b-row>
      </div>
      <l-map :zoom="zoom" :center="center">
        <l-tile-layer :url="url" />
        <l-marker
          v-for="marker in markerLatLng"
          :key="marker.id"
          :lat-lng="marker"
          :icon="icon"
        >
          <l-popup
            >{{ marker.title }} <vs-divider></vs-divider
            >{{ marker.description }}</l-popup
          >
        </l-marker>
      </l-map>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 20px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import Store from "../../store/store";
import state from "../../store/state";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { latLng, icon, Icon } from "leaflet";
import vSelect from "vue-select";
export default {
  data() {
    return {
      localeText: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      secilenDurum: "",
      durumList: [],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 6,
      center: [39.9272, 32.8644],
      markerLatLng: [],
      icon: icon({
        iconUrl: require("@/assets/images/misc/placeholder.png"),
        iconSize: [30, 30],
        iconAnchor: [16, 37],
      }),
    };
  },

  components: {
    AgGridVue,
    "v-select": vSelect,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    currencyFormatter(currency) {
      var parfloat = parseFloat(currency);

      if (typeof currency == "undefined" || currency == null) return "";
      else {
        var sansDec = parfloat.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return "₺" + `${formatted}`;
      }
    },
    yilDeger() {
      this.getHaritaList();
      this.getHaritaDetay();
    },
    getYears() {
      const today = new Date();
      const a = new Date(today);
      for (let index = 2014; index <= a.getFullYear(); index++) {
        this.durumList.push({
          name: index,
          val: index,
        });
      }
    },
    getHaritaList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var yildegeri = vm.secilenDurum.val;
      if (typeof yildegeri == "undefined") {
        yildegeri = "2014";
      }
      const args = {
        token: Store.state.tokenId,
        secilen: yildegeri,
      };
      soap.createClient(url, function (err, client) {
        client.INT_HARITALIST(args, function (err, result) {
          if (result.INT_HARITALISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.INT_HARITALISTResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.markerLatLng = list;
            } else {
            }
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    getHaritaDetay() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var yildegeri = vm.secilenDurum.val;
      if (typeof yildegeri == "undefined") {
        yildegeri = "2014";
      }
      const args = {
        token: Store.state.tokenId,
        secilen: yildegeri,
      };
      console.log(args);
      soap.createClient(url, function (err, client) {
        client.INT_HARITADETAY(args, function (err, result) {
          if (result.INT_HARITADETAYResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.INT_HARITADETAYResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
            } else {
            }
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  created() {
    this.getHaritaList();
    this.getHaritaDetay();
    this.getYears();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Şehir",
        field: "SEHIR",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Satış",
        field: "SATIS",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.SATIS),
        type: "rightAligned",
      },
      {
        headerName: "Sipariş",
        field: "SIPARIS",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.SIPARIS),
        type: "rightAligned",
      },
      {
        headerName: "Tahsilat",
        field: "TAHSILAT",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TAHSILAT),
        type: "rightAligned",
      },
    ];
  },
};
</script>
<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>